import useImperativeNetworkRequestBase from '@root/core/src/hooks/use-imperative-network-request-base';
import useSafeNetworkRequest from '@root/core/src/hooks/use-safe-network-request';

export default function useSafeImperativeNetworkRequest(requestConfigurationFunction) {
  return useImperativeNetworkRequestBase(requestConfigurationFunction, useSafeNetworkRequest);
}
